// Copyright © 2022 Vewd Software AS.
//
// This file is part of Vewd Cloud,
// and includes Vewd Confidential Information.
// Distribution is strictly prohibited without Vewd's written consent.
import PropTypes from "prop-types";

import { Header } from "components/elements";
import { TextOverflowPopup } from "components/popups";
import { classes } from "utils/classes";

import styles from "./PageHeader.scss";

/**
 * @typedef {Object} HeaderProps
 * @property {React.ReactNode} children - Text of the header
 * @property {string} [className] - Additional CSS class names
 */

/**
 * Page header component. Mainly used with [PageContent](#pagecontent).
 * @param {HeaderProps} props - The component props
 * @returns {JSX.Element} The rendered header component
 */
export const PageHeader = ({ children, className }) => (
  <div className={classes(styles.container, className)}>
    <Header type="h2" bold={true}>
      {typeof children === "string" ? (
        <TextOverflowPopup>{children}</TextOverflowPopup>
      ) : (
        children
      )}
    </Header>
  </div>
);

PageHeader.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};
